// extracted by css-extract-rspack-plugin
export default {"content":"_ba3859a0"};